<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Kontinuität</h1>
                <p class="h2">...und jeden Tag ihre Ziele zu verfolgen</p>
            </div>
            <div class="right-wrapper">
                <h2>Warum ist Kontinuität wichtig?</h2>
                <p class="text">Kontinuität ist die Grundlage für nachhaltige Veränderungen.Wenn es darum geht, kleine, gesunde Gewohnheiten zu etablieren, verstärkt wiederholtes Üben ein positives Verhalten, so dass es mit der Zeit Wurzeln schlagen und gedeihen kann.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 18
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

